<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="start"><a id="part1"></a>PART ONE</h1>
<h1 class="center" id="heading_id_2"><i>Paul: The Realist</i><br/>
  1922</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-start.vue?3a7f7480